import React, { FC } from 'react'
import AccordionText from '../../common/AccordionText/AccordionText'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import { ICity } from '../../types'
import Shop from '../Shop/Shop'
import css from './List.module.scss'

const List: FC<{ cities: ICity[] }> = ({ cities }) => {
  return (
    <section className={css.wrapper}>
      <MaxWidth>
        <ul className={css.inner}>
          {cities.map((city) => {
            if (city.shops.length === 0) {
              return null
            }

            return (
              <li key={city.code}>
                <AccordionText
                  title={
                    <span className={css.accordeon_title}>
                      {city.name}
                      <sup>{city.shops.length}</sup>
                    </span>
                  }
                  bigCross
                >
                  <ul className={css.cities}>
                    {city.shops.map((shop, index) => (
                      <Shop
                        key={shop.code}
                        shop={shop}
                        border={
                          (city.shops.length > 3 &&
                            index < city.shops.length - 2 &&
                            index < city.shops.length - 1) ||
                          (city.shops.length === 3 &&
                            index < city.shops.length - 1)
                        }
                        single={city.shops.length === 1}
                      />
                    ))}
                  </ul>
                </AccordionText>
              </li>
            )
          })}
        </ul>
      </MaxWidth>
    </section>
  )
}

export default List
